// extracted by mini-css-extract-plugin
module.exports = {"account-page":"styles_account-page__1oT4w"};